import imageResizedView from './imageResizedComponent.html';
import './imageResizedComponent.css';

export function imageResizedComponent() {
	return {
		bindings: {
			image: '<',
			geometry: '<',
			alt: '@',
		},
		controllerAs: 'vm',
		controller: imageResizedComponentCtrl,
		template: imageResizedView,
	};
}

export class imageResizedComponentCtrl {
	constructor(ImageSizer) {
		'ngInject';
		this.ImageSizer = ImageSizer;
	}

	$onChanges() {
		if (this.image) {
			[this.width, this.height] = this.ImageSizer.getSize(this.image, this.geometry);
			this.src = this.ImageSizer.url(this.image.url, this.geometry);
		}
	}
}
